<template>
  <Sidebar :showSidebar="showSidebar" v-on:hideSideBar="showSide()" />
  <Navbar @clicked="showSide" />

  <router-view></router-view>
</template>

<script>
import router from "../router";
import Navbar from "./Navbar.vue";
import Sidebar from "./Sidebar.vue";
export default {
  components: { Sidebar, Navbar },

  data() {
    return {
      showSidebar: false,
      gameOver: null,
      hoursLeft: null,
      account: null,
      currentRoute: null,
      expiredDate: null,
      winningToken: 0,
    };
  },
  mounted() {
    // validate session on mounting page
    if (!localStorage.getItem("wax_user")) {
      router.push("/login");
    }
  },
  methods: {
    showSide: function () {
      this.showSidebar =!this.showSidebar;
    },
    logout: function () {
      router.push("/login");
    },
  },
};
</script>
